import { required, integer, helpers, requiredIf } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      role_id: {
        required: helpers.withMessage(i18n.global.t('Please select a role.'), required),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
      },
      access_all_branches: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required),
      },
      branch_ids: {
        required: helpers.withMessage(i18n.global.t('Please select branch.'), requiredIf(formState.access_all_branches == false)),
        $each: helpers.forEach({
          required: helpers.withMessage(i18n.global.t('Please select branch.'), required),
          integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
        })
      }
    }
  }
};
